import { twMerge } from '@/utils/tw-merge';

export const Divider = ({ className }: { className?: string }) => {
  return (
    <hr
      className={twMerge('border-b border-t-0 border-b-gray-300', className)}
    />
  );
};
